<template>
	<div class="form-inputs" @keyup.space="showPicker">
		<FormLabelTooltip v-if="label" :name="`${name}`" :label="label" />
		<Datepicker
			:value="value"
			:calendarClass="calendarClass"
			:clearButton="clearButton"
			:disabled="disabled"
			:format="format"
			:fullMonthName="fullMonthName"
			:id="id"
			:inputClass="inputClass"
			:maximumView="maximumView"
			:name="name"
			:placeholder="placeholder"
			:required="required"
			@input="$emit('input', $event)"
			ref="datepicker"
		/>
	</div>
</template>

<script>
/* 
FormDatePicker is a wrapper for vuejs-datepicker with a few features added to
improve accessibility. Only the features that could be tested with our 
project have been implemented.
See: https://github.com/charliekassel/vuejs-datepicker#readme
Visit the link above to see the additional features that could be added.
*/
import Datepicker from 'vuejs-datepicker';
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';

export default {
	name: 'FormDatepicker',
	components: {
		Datepicker,
		FormLabelTooltip,
	},
	props: {
		calendarClass: {
			type: [String, Object, Array],
			default: 'form-datepicker-calendar',
		},
		clearButton: Boolean,
		disabled: Boolean,
		format: {
			type: [String, Function],
			default: 'MMMM dd, yyyy',
		},
		fullMonthName: Boolean,
		id: String,
		inputClass: {
			type: [String, Object, Array],
			default: 'form-datepicker',
		},
		label: String,
		maximumView: {
			type: String,
			default: 'year',
		},
		name: String,
		placeholder: String,
		required: Boolean,
		value: [String, Date],
	},
	methods: {
		showPicker() {
			if (!this.disabled) {
				this.$refs.datepicker.showCalendar();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .vdp-datepicker {
	.vdp-datepicker__calendar {
		.cell {
			@include rem('border-radius', 6px);
			&.selected {
				background: $brand-blue;
				color: $white;
			}
		}
	}
	.vdp-datepicker__clear-button {
		position: absolute;
		@include rem('top', 5px);
		right: 0;
		color: $b360-color--gray__darker;
		&:hover {
			color: $brand-blue;
		}
		& > span {
			display: inline-block;
			@include rem('padding', 10px 18px 10px 0px);
		}
		i {
			font-style: normal;
		}
	}
	.form-datepicker {
		width: 100%;
		border: 1px solid $border-color-light;
		color: $b360-color--gray__darkest;
		@include rem('margin-top', 2px);
		@include rem('margin-bottom', 2px);
		@include rem('padding', 12px);
		@include rem('border-radius', 6px);
		@include rem('font-size', 16px);
		cursor: pointer;
		&:focus {
			outline: none;
			box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
		}
	}
	.form-datepicker-calendar {
		@include rem('right', 0);
		@include rem('border-radius', 6px);
		width: 100%;
	}
}
</style>
